<template>
  <v-container fluid>
    <template v-if="showPazymosTable">
      <h3 v-if="showTitle" class="mb-3">{{ sarasasTitle }}</h3>
      <v-data-table
        :loading="loading"
        :headers="filteredHeaders"
        :items="filteredItemsList"
        :search="search"
        :hide-default-footer="hideFooter"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :items-per-page="pagination.pageSize"
        :page.sync="pagination.page"
        :expanded.sync="expanded"
        item-key="paz_id"
      >
        <template #[`item.dokumentas`]="{ item }">
          <v-row dense no-gutters justify="center">
            <el-prasymas-busena
              class="my-1"
              :busena="item.paz_busena_pavadinimas"
            />
          </v-row>
          <v-row dense no-gutters justify="center">
            <b>{{ item.paz_id }}</b>
          </v-row>
        </template>
        <template #[`item.busena`]="{ item }">
          <el-prasymas-busena
            class="my-1"
            :busena="item.paz_busena_pavadinimas"
          />
        </template>
        <template #[`item.actions`]="{ item }">
          <el-byla
            v-for="byla in item.bylos"
            :key="byla.byl_id"
            :byla="byla"
            in-line
            color="primary"
          />
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
            @deleteItem="deleteItem(item)"
          />

          <el-button
            v-if="item.canMoketi"
            small
            :loading="loading"
            @click.native="moketiItem(item)"
            >{{ $t('Mokėti') }}</el-button
          >
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="pazyma-expanded"></td>
          <td :colspan="headers.length - 2" class="pazyma-expanded">
            {{ $t('Atmetimo priežastis:') }} {{ item.paz_atmetimo_priezastis }}
          </td>
          <td class="pazyma-expanded"></td>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>

    <modal-delete
      :title="$t('Šalinti užsakymą?')"
      :text="
        $t('Ar norite pašalinti') + ` <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import PazymaMap from './PazymaMap'
import ModalDelete from '../modals/ModalDelete'
import pazymaVeiksmas from './pazymaVeiksmas'

export default {
  name: 'PazymosUzsakytos',
  components: { ModalDelete },
  mixins: [pazymaVeiksmas],
  props: {
    pazymaKodas: String,
  },
  data() {
    return {
      loading: true,
      loadingTable: true,
      search: null,
      searchData: {},
      pazymos: [],

      itemsPerPageOptions: [10, 50, 100, -1],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },

      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      expanded: [],
      refreshTimer: null,
      refreshTimeout: 2000,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Dokumento numeris',
          align: 'center',
          value: 'dokumentas',
          sortable: false,
          width: 100,
        },
        {
          text: 'Dokumento pavadinimas',
          align: 'start',
          value: 'tipas_pavadinimas',
          sortable: false,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'paz_busenos_data',
          sortable: false,
          width: 100,
        },
        {
          text: 'Veiksmai',
          align: 'start',
          value: 'actions',
          sortable: false,
          width: 100,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filteredItemsList() {
      let eil_nr = 1

      return this.pazymos.map(pazyma => {
        pazyma.eil_nr = eil_nr++

        pazyma.bylos = pazyma.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`,
          }
        })

        pazyma.canView = pazyma.veiksmai.includes('pazyma-perziura')
        pazyma.canEdit = pazyma.veiksmai.includes('pazyma-redagavimas')
        pazyma.canDelete = pazyma.veiksmai.includes('pazyma-salinimas')

        pazyma.canMoketi = pazyma.veiksmai.includes('pazyma-mokejimas')

        if (pazyma.paz_busena === 'atmestas') {
          this.expanded.push({ paz_id: pazyma.paz_id })
        }

        return pazyma
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    pazymaMap() {
      return PazymaMap.getPazymaTipas(this.pazymaKodas)
    },
    pazymaTipas() {
      return this.pazymaMap.tipas
    },
    sarasasTitle() {
      return this.pazymaMap.sarasasTitle
    },
    showPazymosTable() {
      return this.pazymos.length > 0
    },
    loadingData() {
      const loadingItems = this.pazymos.filter(pazyma => {
        return pazyma.paz_busena === 'vykdomas'
      })
      return loadingItems.length > 0
    },
    isTipasSklypas() {
      return this.pazymaTipas == 'zemes-sklypas'
    },
    showTitle() {
      return !this.isTipasSklypas
    },
  },
  created() {
    this.getData()
  },
  methods: {
    checkLoading() {
      if (this.loadingData) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            if (this.refreshTimer) {
              this.getData(true)
            }
          }, this.refreshTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    },
    getData(silent = false) {
      if (!silent) {
        this.loading = true
      }

      const data = {
        pazyma_tipas: this.pazymaKodas,
      }

      this.$axios
        .post(`ntrpaslaugos/pazyma/uzsakytos-pazymos`, data)
        .then(res => {
          this.pazymos = res.data.uzsakytos_pazymos
          this.pagination.total = this.pazymos.length
          this.checkLoading()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          if (!silent) {
            this.$emit('loaded', this.pazymos.length)
          }
        })
    },
    editItem(item) {
      this.$emit('edit', item)
    },
    moketiItem(item) {
      this.pazymaMoketi(item.paz_id)
    },
    updatePazyma() {
      this.getData()
    },
    deleteItem(item) {
      this.modalDeleteVardas = `${this.pazymaMap.deleteText} ${item.paz_id}`
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.confirmDeleteItem(item)
    },
    confirmDeleteItem(item) {
      this.$axios
        .delete(`ntrpaslaugos/pazyma/${item.paz_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.updateList()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    updateList() {
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.pazyma-expanded {
  box-shadow: none;
  background: rgb(248, 248, 248);
  padding-top: 0px !important;
}
</style>
